import {
    fetchTaxEntities,
    fetchAccounts,
    fetchAllUsers,
    fetchBenefitPlans,
    fetchGetLatestTemplateRiderComponent,
    fetchJvBrokers,
    fetchJvClients,
    fetchRidersFromHrp,
    fetchSuppliers,
    fetchTags,
    fetchTemplateRiderComp,
    fetchServices,
    fetchPlaceOfService,
    fetchDiagnosis,
    fetchTypeOfBill,
    fetchModifiers,
    fetchProcedureCodes,
    fetchTemplatesFromHrpProxy,
    getAccountsByParentAccountKeyAndAccountLevel,
} from "./apiUtils";

const loadClients = async (search, loadedOptions, additional = {}) => {
    let params = {
        ...additional,
        offset: loadedOptions.length,
    };

    if (search) {
        params.clientName = search;
    }

    const data = await fetchJvClients(params);
    return {
        options: data.rows.map((row) => ({
            value: row.clientid,
            label: `${row.clientid}: ${row.clientname}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: row
        })),
        // options: data.rows,
        hasMore: loadedOptions.length < data.total,
    };
};

const loadJVBrokerss = async (search, loadedOptions, additional = {}) => {
    let params = {
        ...additional,
        offset: loadedOptions.length,
    };

    if (search) {
        params.brokerName = search;
    }

    const data = await fetchJvBrokers(params);
    return {
        options: data.rows.map((row) => ({
            value: row.code,
            label: `${row.code}: ${row.brokername}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: row
        })),
        // options: data.rows,
        hasMore: loadedOptions.length < data.total,
    };
};

const loadAccounts = async (search, loadedOptions, additional = {}) => {
    let params = {
        ...additional,
        limit: 50,
        //   canHaveSubscr: 'Y',
        offset: loadedOptions.length,
    };
    if (search) {
        // params.accountHccId = search;
        params.searchText = search;
    }
    console.log(params)
    const data = await getAccountsByParentAccountKeyAndAccountLevel(params);
    return {
        options: data.rows.map((row) => ({
            value: row.accountKey,
            label: `${row.accountName} (${row.accountHccId} | ${row.accountKey}) ${row.subAccountsCount ? ` - Sub accounts (${row.subAccountsCount})` : ''}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: row,
        })),
        // options: data.rows,
        hasMore: loadedOptions.length < data.count,
    };
};

const loadAccountHccIdentificationNumber = async (search, loadedOptions) => {
    let params = {
        limit: 50,
        //   canHaveSubscr: 'Y',
        offset: loadedOptions.length,
    };
    if (search) {
        // params.accountHccId = search;
        params.accountName = search;
    }
    const data = await fetchAccounts(params);
    return {
        options: data.rows.map((row) => ({
            value: row.accountHccId,
            label: `${row.accountName} (${row.accountHccId})`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: row,
        })),
        // options: data.rows,
        hasMore: loadedOptions.length < data.count,
    };
};

const loadTaxEntities = async (search, loadedOptions) => {
    const limit = 50;
    let params = {
        limit: limit,
        offset: loadedOptions.length,
    };
    if (search) {
        params.searchText = search;
    }
    const data = await fetchTaxEntities(params);
    return {
        options: data.rows.map((row) => ({
            value: row.taxId,
            label: `${row.taxName} (${row.taxId})`,
            additional: row,
        })),
        hasMore: (loadedOptions.length + limit) < data.count,
    };
}

const loadSupplier = async (search, loadedOptions) => {
    let params = {
        limit: 50,
        //   canHaveSubscr: 'Y',
        offset: loadedOptions.length,
    };
    if (search) {
        // params.accountHccId = search;
        params.searchText = search;
    }
    const data = await fetchSuppliers(params);
    return {
        options: data.rows.map((row) => ({
            value: row.supplierHccId,
            label: `${row.supplierName} (${row.supplierHccId})`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: row,
        })),
        // options: data.rows,
        hasMore: loadedOptions.length < data.count,
    }
};

const loadTemplates = async (search, loadedOptions) => {
    //  console.log({ loadedOptions: loadedOptions.length })
    let params = {
        limit: 10,
        //   canHaveSubscr: 'Y',
        offset: loadedOptions.length,
    };

    if (search) {
        params.benefitPlanTemplateName = search;
    }

    const data = await fetchTemplatesFromHrpProxy(params);

    return {
        options: data.rows.map((row, i) => ({
            value: row.bnftPlanTemplateHstFctKey,
            label: `${row.benefitPlanTemplateName}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: row,
        })),
        // options: data.rows,
        hasMore: loadedOptions.length < data.count,
    };
};

const loadRidersOld = async (search, loadedOptions, { benefitPlanTemplateKey, category }) => {

    const lastLoadedOption = loadedOptions?.at(-1)

    let params = {
        category,
        benefitPlanTemplateKey
    };

    if (lastLoadedOption) {
        params.searchAfter = lastLoadedOption.additional.sort;
    }

    if (search) {
        params.searchText = search;
    }

    const data = await fetchTemplateRiderComp(params);
    const hits = data.hits.hits
    const lastHit = hits?.map(hit => hit._source.metadata).filter((metadata) => !!metadata.benefitPlanRiderHccId).at(-1);
    const sort = lastHit?.sort

    return {
        options: hits?.map(hit => hit._source.metadata)
            .filter((metadata) => !!metadata.benefitPlanRiderHccId)
            .map((metadata, i) => {

                return {
                    value: metadata?.benefitPlanRiderHccId,
                    label: `${metadata?.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
                    additional: metadata,
                }
            }),
        // options: data.rows,
        hasMore: !!sort
    };
};

const loadRiders = async (search, loadedOptions, { benefitPlanTemplateKey, category }) => {
    //  console.log({ loadedOptions: loadedOptions.length })
    let params = {
        limit: 1000,
        benefitPlanTemplateKey,
        slotName: category,
        offset: loadedOptions.length,
    };

    if (search) {
        params.searchText = search;
    }

    const data = await fetchGetLatestTemplateRiderComponent(params);

    return {
        options: data.rows.map((row, i) => ({
            value: row.benefitPlanRiderHccId,
            label: `${row.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: row,
        })),
        // options: data.rows,
        hasMore: loadedOptions.length < data.count,
    };
};

const loadBenefitPlans = async (search, loadedOptions) => {
    let params = {
        limit: 50,
        //   canHaveSubscr: 'Y',
        offset: loadedOptions.length,
    };

    if (search) {
        // params.accountHccId = search;
        params.benefitPlanName = search;
    }

    const data = await fetchBenefitPlans(params);
    return {
        options: data.rows.map((row) => ({
            value: row.benefitPlanHccId,
            label: `${row.benefitPlanName} (${row.benefitPlanHccId})`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: row,
        })),
        // options: data.rows,
        hasMore: loadedOptions.length < data.count,
    };
};

const loadUsers = async (search, loadedOptions, additional) => {
    let params = { limit: 10 }

    if (additional?.lastEvaluatedKey) {
        params.lastEvaluatedKey = encodeURIComponent(JSON.stringify(additional.lastEvaluatedKey))
    }

    if (search) {
        params.emailPrefix = search;
    }
    const data = await fetchAllUsers(params)

    const lastEvaluatedKey = data.LastEvaluatedKey
    //TODO lastevaluation key
    return {
        options: data.Items?.map(item => ({ label: item.pk, value: item.pk })),
        hasMore: !!lastEvaluatedKey,
        additional: { lastEvaluatedKey }

    }

};

const loadRidersFromHrp = async (search, loadedOptions) => {
    //  console.log({ loadedOptions: loadedOptions.length })
    let params = {
        limit: 10,
        //   canHaveSubscr: 'Y',
        offset: loadedOptions.length,
    };

    if (search) {
        params.benefitPlanRiderHccId = search;
    }

    const data = await fetchRidersFromHrp(params);
    // console.log({ loadedOptions: loadedOptions.length, data: data.count });
    return {
        options: data.rows.map((row, i) => ({
            value: row.benefitPlanRiderKey,
            label: `${row.benefitPlanRiderKey} | ${row.bnftPlanRiderHistFactKey} | ${row.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: row,
        })),
        // options: data.rows,
        hasMore: loadedOptions.length < data.count,
    };
};

// const loadMemberUdt = async (search, loadedOptions) => {
//     //  console.log({ loadedOptions: loadedOptions.length })
//     let params = {
//         limit: 10,
//         //   canHaveSubscr: 'Y',
//         offset: loadedOptions.length,
//     };

//     if (search) {
//         params.coverageTierSetName = search;
//     }

//     const data = await apiUtils.fetchCoverageTierSetHistoryFact(params);
//     console.log({ loadedOptions: loadedOptions.length, data: data.count });
//     return {
//         options: data.rows.map((row, i) => ({
//             value: row.coverageTierSetKey,
//             label: `${row.coverageTierSetName}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
//             additional: row,
//         })),
//         // options: data.rows,
//         hasMore: loadedOptions.length < data.count,
//     };
// };

const loadTags = async (search, loadedOptions, additional) => {

    let params = { limit: 10 }

    if (additional?.lastEvaluatedKey) {
        params.lastEvaluatedKey = encodeURIComponent(JSON.stringify(additional.lastEvaluatedKey))
    }

    if (search) {
        params.skPrefix = search;
    }
    const data = await fetchTags(params)

    const lastEvaluatedKey = data.LastEvaluatedKey
    let options = data.Items?.map(item => ({ label: item.sk, value: item.sk }))

    if (loadedOptions?.filter) {
        options = options.filter(option => !loadedOptions.filter.includes(option.value))
    }

    return {
        options,
        hasMore: !!lastEvaluatedKey,
        additional: { lastEvaluatedKey }

    }

};

const loadServices = async (search, loadedOptions) => {
    const limit = 30;
    const params = {
        limit,
        offset: loadedOptions.length,
    };
    if (search) params.searchText = search;

    const data = await fetchServices(params);
    const rows = data.rows || [];
    return {
        options: rows.map((row) => ({
            value: row.serviceCode,
            label: row.serviceShortDesc
                ? `${row.serviceCode} — ${row.serviceShortDesc}`
                : row.serviceCode,
            additional: row,
        })),
        hasMore: loadedOptions.length + rows.length < (data.count || 0),
    };
};

const paginatedCodeLoader = ({ fetch, valueKey, labelKey, extraParams = {}, limit = 30 }) =>
    async (search, loadedOptions) => {
        const params = {
            limit,
            offset: loadedOptions.length,
            ...extraParams,
        };
        if (search) params.searchText = search;
        const data = await fetch(params);
        const rows = data.rows || [];
        return {
            options: rows.map((row) => ({
                value: row[valueKey],
                label: row[labelKey] ? `${row[valueKey]} — ${row[labelKey]}` : row[valueKey],
                additional: row,
            })),
            hasMore: loadedOptions.length + rows.length < (data.count || 0),
        };
    };

const loadPlaceOfService = paginatedCodeLoader({
    fetch: fetchPlaceOfService,
    valueKey: "placeOfServiceCode",
    labelKey: "placeOfServiceDesc",
    limit: 40,
});

const loadRevenueCodes = paginatedCodeLoader({
    fetch: fetchServices,
    valueKey: "serviceCode",
    labelKey: "serviceShortDesc",
    extraParams: { serviceTypeName: "UB Revenue Code" },
});

const loadTypeOfBill = paginatedCodeLoader({
    fetch: fetchTypeOfBill,
    valueKey: "typeOfBillCode",
    labelKey: "typeOfBillDesc",
});

const loadDiagnosis = paginatedCodeLoader({
    fetch: fetchDiagnosis,
    valueKey: "diagnosisCode",
    labelKey: "diagnosisShortDesc",
});

const loadModifiers = paginatedCodeLoader({
    fetch: fetchModifiers,
    valueKey: "modifierCode",
    labelKey: "modifierName",
});

const loadProcedureCodes = paginatedCodeLoader({
    fetch: fetchProcedureCodes,
    valueKey: "procedureCode",
    labelKey: "procedureShortDesc",
});

export {
    loadAccounts,
    loadAccountHccIdentificationNumber,
    loadTaxEntities,
    loadTemplates,
    loadRiders,
    loadBenefitPlans,
    loadUsers,
    loadRidersFromHrp,
    loadClients,
    loadJVBrokerss,
    loadSupplier,
    loadTags,
    loadServices,
    loadPlaceOfService,
    loadRevenueCodes,
    loadTypeOfBill,
    loadDiagnosis,
    loadModifiers,
    loadProcedureCodes,
}
